import React from 'react'

import { useLocation } from 'react-router-dom'

import { Logo, Nav, NavList } from './components'
import Banner from './components/Banner'

export const Navbar: React.FC = () => {
  const location = useLocation()
  const privateRoutes = [
    'member-search',
    'referral-management',
    'practice-profile',
    'practice-reports',
    'plan',
  ]

  const isPrivateRoute = privateRoutes.some(route =>
    location.pathname.includes(route)
  )
  return (
    <header>
      <Nav isPrivateRoute={isPrivateRoute}>
        <Logo />
        {isPrivateRoute && <NavList />}
      </Nav>
    </header>
  )
}
